import React from "react";
import ChartWrapper from "../graph/ChartWrapper";
import {
  CardData,
  CategoryDef,
} from "api/interfaces/dashboardInterface.interface";
import { getDashboardUserStats } from "api/widgetAPI";
import useStatsData from "hook/useStatsData";

export default function Users(props: CardData) {
  const { statsData, data, legend, interval, setInterval } = useStatsData({
    queryFn: getDashboardUserStats,
    queryName: "usersStatsGraph",
    items: props.items as CategoryDef[],
  });
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      onChangeInterval={setInterval}
      interval={interval}
      legend={legend}
      isLoading={statsData.isLoading}
    />
  );
}
